import axios from "../axios";
// 获取学科列表
export const getTeacherList = (data) => {
  return axios({
    url: "/console/teacher/list",
    method: "GET",
    data: data,
  });
};

// 添加教师
export const addTeacher = (data) => {
  return axios({
    url: "/console/teacher/save",
    method: "POST",
    data,
  });
};

// 获取年级列表
export const getGradeList = (data) => {
  return axios({
    url: "/console/school/grade",
    method: "GET",
    data: data,
  });
};

// 获取学科列表
export const getSubList = (data) => {
  return axios({
    url: "/console/school_subject/enable_list",
    method: "GET",
    data: data,
  });
};

// 教师详情
export const getTeacherInfo = (data) => {
  return axios({
    url: "/console/teacher/classList",
    method: "GET",
    data: data,
  });
};

// 启用禁用教师
export const changeStatus = (data) => {
  return axios({
    url: "/console/teacher/changeStatus",
    method: "POST",
    data,
  });
};

// 移除教师
export const removeTeachClass = (data) => {
  return axios({
    url: "/console/teacher/removeClassForTeacher",
    method: "POST",
    data,
  });
};

// 家长管理列表
export const getParentList = (data) => {
  return axios({
    url: "/console/parent/page",
    method: "GET",
    data,
  });
};

// 添加家长
export const addParent = (data) => {
  return axios({
    url: "/console/parent/save",
    method: "POST",
    data,
  });
};

// 家长详情
export const getParentInfo = (data) => {
  return axios({
    url: "/console/parent/detail",
    method: "GET",
    data,
  });
};

// 移除孩子
export const removeParentChild = (data) => {
  return axios({
    url: "/console/parent/remove_child",
    method: "POST",
    data,
  });
};

// 禁用家长
export const disParent = (data) => {
  return axios({
    url: "/console/parent/switch",
    method: "POST",
    data,
  });
};



// WEBPACK FOOTER //
// ./src/http/moudules/roleManagement.js